(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/aria-utils/assets/javascripts/compose-result-update-text.js') >= 0) return;  svs.modules.push('/components/pool-betting/aria-utils/assets/javascripts/compose-result-update-text.js');
"use strict";


const _svs$components$sport = svs.components.sportinfo.common.constants,
  EventTypeId = _svs$components$sport.EventTypeId,
  EventTypeDescriptions = _svs$components$sport.EventTypeDescriptions;
const SportTypes = svs.components.sport.sportTypes.SportTypes;
const composeUpdateResultTextDefault = _ref => {
  let eventDescription = _ref.eventDescription,
    eventNumber = _ref.eventNumber,
    numberOfGoalsHomeTeam = _ref.numberOfGoalsHomeTeam,
    numberOfGoalsAwayTeam = _ref.numberOfGoalsAwayTeam,
    periodNumber = _ref.periodNumber;
  const isPeriod = periodNumber > 0;
  if (isPeriod) {
    return "\xC4ndrat resultat f\xF6r period ".concat(periodNumber, ", ").concat(eventDescription, ".\n          Resultat: ").concat(numberOfGoalsHomeTeam || 0, " - ").concat(numberOfGoalsAwayTeam || 0, ".");
  }
  return "\xC4ndrat resultat f\xF6r event ".concat(eventNumber, ", ").concat(eventDescription, ".\n          Resultat: ").concat(numberOfGoalsHomeTeam || 0, " - ").concat(numberOfGoalsAwayTeam || 0, ".");
};
const composeUpdateResultText1X2 = _ref2 => {
  let eventComment = _ref2.eventComment,
    eventDescription = _ref2.eventDescription,
    eventNumber = _ref2.eventNumber,
    eventTypeId = _ref2.eventTypeId,
    numberOfGoalsHomeTeam = _ref2.numberOfGoalsHomeTeam,
    numberOfGoalsAwayTeam = _ref2.numberOfGoalsAwayTeam,
    outcome = _ref2.outcome;
  if (eventTypeId === EventTypeId.AMOUNT || eventTypeId === EventTypeId.EVENT_1_2 || eventTypeId === EventTypeId.HEAD_TO_HEAD || eventTypeId === EventTypeId.OVER_UNDER || eventTypeId === EventTypeId.LEAST_AMOUNT_OF_GOALS) {
    return "\xC4ndrat utfall f\xF6r event ".concat(eventNumber, ", ").concat(eventDescription, ", ").concat(eventComment || EventTypeDescriptions[eventTypeId], ".\n          Utfall ").concat(outcome ? outcome : 'Ej spelbart alternativ', ".\n          Resultat: ").concat(numberOfGoalsHomeTeam || 0, " - ").concat(numberOfGoalsAwayTeam || 0, ".");
  }
  return "\xC4ndrat utfall f\xF6r match ".concat(eventNumber, ", ").concat(eventDescription, ".\n          Utfall ").concat(outcome ? outcome : '-', ".\n          Resultat: ").concat(numberOfGoalsHomeTeam || 0, " - ").concat(numberOfGoalsAwayTeam || 0, ".");
};
const composeUpdateResultTextTrotting = _ref3 => {
  let eventDescription = _ref3.eventDescription,
    eventNumber = _ref3.eventNumber,
    outcome = _ref3.outcome;
  return "\xC4ndrat utfall f\xF6r match ".concat(eventNumber, ", ").concat(eventDescription, ". Utfall ").concat(outcome ? outcome : '-', ".");
};
const composeResultUpdateText = _ref4 => {
  let eventComment = _ref4.eventComment,
    eventTypeId = _ref4.eventTypeId,
    eventNumber = _ref4.eventNumber,
    eventDescription = _ref4.eventDescription,
    numberOfGoalsHomeTeam = _ref4.numberOfGoalsHomeTeam,
    numberOfGoalsAwayTeam = _ref4.numberOfGoalsAwayTeam,
    outcome = _ref4.outcome,
    periodNumber = _ref4.periodNumber,
    sportType = _ref4.sportType;
  const isTrotting = sportType && sportType === SportTypes.Trotting;
  if (isTrotting) {
    return composeUpdateResultTextTrotting({
      eventDescription,
      eventNumber,
      outcome
    });
  }
  const isHead2Head = eventTypeId === EventTypeId.HEAD_TO_HEAD;
  let changedResultText;
  if (eventTypeId === EventTypeId.RESULT) {
    changedResultText = composeUpdateResultTextDefault({
      eventTypeId,
      eventComment,
      eventDescription,
      eventNumber,
      numberOfGoalsHomeTeam,
      numberOfGoalsAwayTeam,
      periodNumber
    });
  } else {
    changedResultText = composeUpdateResultText1X2({
      eventDescription,
      eventNumber,
      eventTypeId,
      isHead2Head,
      numberOfGoalsHomeTeam,
      numberOfGoalsAwayTeam,
      outcome
    });
  }
  return changedResultText;
};
setGlobal('svs.components.poolBetting.ariaUtils', {
  composeResultUpdateText,
  composeUpdateResultText1X2
});

 })(window);